import { render } from "./ParentProductCategoriesListModal.vue?vue&type=template&id=b6b8ae64&scoped=true"
import script from "./ParentProductCategoriesListModal.vue?vue&type=script&lang=js"
export * from "./ParentProductCategoriesListModal.vue?vue&type=script&lang=js"

import "./ParentProductCategoriesListModal.vue?vue&type=style&index=0&id=b6b8ae64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b8ae64"]])

export default __exports__